import { render, staticRenderFns } from "./Tab2.vue?vue&type=template&id=35f49a99&scoped=true&"
import script from "./Tab2.vue?vue&type=script&lang=ts&"
export * from "./Tab2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f49a99",
  null
  
)

export default component.exports